<template>
  <div class="login-wrapper">
    <div class="middle" v-if="is_login">
      <div class="text-center text-muted">21世纪房车 · 创作中心</div>
      <div class="tit">
        <button class="text-muted" :class="active == 1 ? 'active' : ''" @click="active = 1">手机号登录</button>
        <button class="text-muted" :class="active == 2 ? 'active' : ''" @click="active = 2">账号登录</button>
      </div>
      <el-form :model="formData" :rules="rules" ref="formData" @submit.native.prevent="submitForm('formData')" v-if="active == 1">
        <el-form-item prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="code-item">
          <el-input v-model="formData.code" placeholder="短信验证码" class="code"></el-input>
          <el-button :disabled="isPhoneValid(formData.phone)" @click="onGetCode" class="code-btn">{{ codeShow ? "获取验证码" : "重新获取" }}
            <span v-show="!codeShow">({{ count }})</span>
          </el-button>
        </el-form-item>
        
        <el-form-item style="text-align: center;margin-bottom:10px;">
          <el-button type="primary" native-type="submit" class="btn-block">登录</el-button>
        </el-form-item>
        <div class=" fs-10 text-muted">
          <el-checkbox v-model="checked"></el-checkbox><span class=" ms-1 cursor-pointer"  @click="checked = true">登录即表示同意<a href="https://api.wanfangche.com/pages/agreement/index.html" class=" text-link" target="_blank">《21世纪房车服务协议》</a>、<a target="_blank" class=" text-link" href="https://blog.wanfangche.com/21rvapp-privacy?from_wecom=1">《隐私政策》</a>、<a target="_blank" class=" text-link" href="https://s.21rv.com/uni/#/pages/standard/community">《21世纪房车社区规范》</a>等,接受<b>免除或者限制责任、诉讼管辖约定</b>等粗体标示条款。</span>
        </div>
      </el-form>
      <div class="" v-if="active == 2">
        <el-form @submit.native.prevent="submitIdForm">
        <el-input class="el-form-item" v-model="idFormData.tel" placeholder="请输入手机号"></el-input>
        <el-input class="el-form-item" v-model="idFormData.passwd" placeholder="请输入密码" type="password"></el-input>
        <div class="el-form-item" style="margin-bottom:10px;"><el-button type="primary" native-type="submit" class="btn-block" >登录</el-button></div>
        <div class=" fs-10 text-muted">
          <el-checkbox v-model="checked"></el-checkbox><span class=" ms-1 cursor-pointer"  @click="checked = true">登录即表示同意<a href="https://api.wanfangche.com/pages/agreement/index.html" class=" text-link" target="_blank">《21世纪房车服务协议》</a>、<a target="_blank" class=" text-link" href="https://blog.wanfangche.com/21rvapp-privacy?from_wecom=1">《隐私政策》</a>、<a target="_blank" class=" text-link" href="https://s.21rv.com/uni/#/pages/standard/community">《21世纪房车社区规范》</a>等,接受<b>免除或者限制责任、诉讼管辖约定</b>等粗体标示条款。</span>
        </div>
        </el-form>
      </div>
      <router-link class=" position-absolute text-danger fs-14" style="right:40px;" :to="{path: 'register', query: $route.query ? $route.query : ''}">立即注册<i class="el-icon-arrow-right"></i></router-link>
    </div>
    <div id="nc"></div>
  </div>
</template>

<script>
import {
  mapActions
} from "vuex";
import store from "@/store";
import UserService from "@/service/UserService";
export default {
  data() {
    return {
      from: encodeURIComponent(window.location.href),
      token: store.state.token,
      formData: {
        phone: "",
        code: "",
      },
      formDatas: {
        phone: "",
        code: "",
      },
      idFormData: {
        tel: '',
        passwd: ''
      },
      rules: {
        phone: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur"
        },
        {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号格式错误",
          trigger: ["blur", "change"],
        },
        ],
        code: [{
          required: true,
          message: "请输入短信验证码",
          trigger: ["blur", "change"],
        },],
      },
      codeShow: true,
      codeShows: true,
      count: "",
      timer: null,
      timers: null,
      active: 1,
      checked: true,
      is_login: true
    };
  },
  methods: {
    ...mapActions(["saveToken"]),
    submit() {
      this.saveToken({
        token: this.token
      });
      if (this.$route.query.from) {
        this.$router.replace(this.$route.query.from)
      } else {
        this.$router.replace("/");
      }
      
    },
    isPhoneValid(tel) {
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(tel)) {
        return true;
      } else {
        return false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$notify({
              title: "提示",
              message: "请勾选同意所有相关协议",
              type: "warning",
            });
          } else {
            UserService.login({
              tel: this.formData.phone,
              tel_code: this.formData.code,
            }).then((res) => {
              if (res.code === 200) {
                this.saveToken({
                  token: res.data.access_token
                });
                window.localStorage.setItem('USER_PHONE', this.formData.phone)
                if (this.$route.query && this.$route.query.from) {
                  this.$router.replace(this.$route.query.from)
                } else {
                  this.$router.replace("/");
                }
              } else {
                this.$notify({
                  title: "错误",
                  message: "验证码错误",
                  type: "error",
                });
              }
            });
          }
        } else {
          return false;
        }
      })
    },
    submitIdForm() {
      if (!this.checked) {
        this.$notify({
          title: "提示",
          message: "请勾选同意所有相关协议",
          type: "warning"
        })
      } else {
        UserService.idLogin(this.idFormData).then(res => {
          this.saveToken({
            token: res.headers.authorization
          })
          window.localStorage.setItem('USER_ID', this.idFormData.tel)
         if (this.$route.query && this.$route.query.from) {
            this.$router.replace(this.$route.query.from)
          } else {
            this.$router.replace("/");
          }
        })
      }
    },
    getCode(data) {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      UserService.getCode({
        tel: this.formData.phone,
        ...data
      }).then((res) => {
      });
    },
    onGetCode() {
      var params = 'a=' + getNVCVal()
      this.yourRegisterRequest('https://cf.aliyun.com/nvc/nvcAnalyze.jsonp', params)
    },
    get_ALY_file () {
      try {
        var stamp = new Date().getTime();
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', 'https://g.alicdn.com/sd/nvc/1.1.112/guide.js?t=' + stamp);
        document.documentElement.appendChild(script);
      } catch (e) {
      }
    },
    set_ALY_config () {
      var _this = this
      return new Promise((resolve,reject) => {
        window.NVC_Opt = {
          appkey:'FFFF0N0000000000996C',
          scene:'nvc_message',
          isH5:false,
          popUp:false,
          renderTo:'#captcha',
          nvcCallback:function(data){
            getALYData(data).then(res => {
              if(res.data.code == 1000 || res.data.code == 100 || res.data.code == 200){ // 无痕验证失败二次验证
                 _this.$message({
                  message: '验证成功',
                  type: 'success'
                });
              } else {
                _this.$message({
                  message: '当前访问用户过多，请刷新后重试!',
                  type: 'error'
                });
              }
            })
          // data为getNVCVal()的值，此函数为二次验证滑动或者刮刮卡通过后的回调函数
          // data跟业务请求一起上传，由后端请求AnalyzeNvc接口，接口会返回100或者900
          },
          // trans: {"nvcCode":600, "key1": "code0"},
          language: "cn",
          //滑动验证长度配置
          customWidth: 300,
          //刮刮卡配置项
          width: 500,
          height: 125,
          elements: [
            "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png",
            "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png"
          ], 
          bg_back_prepared: "//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png",
          bg_front: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC",
          obj_ok: "//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png",
          bg_back_pass: "//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png",
          obj_error: "//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png",
          bg_back_fail: "//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png",
          upLang:{"cn":{
            _ggk_guide: "请摁住鼠标左键，刮出两面盾牌",
            _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
            _ggk_loading: "加载中",
            _ggk_fail: ["呀，盾牌不见了<br/>请","javascript:noCaptcha.reset()","再来一次","或","https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"],
            _ggk_action_timeout: ["我等得太久啦<br/>请","javascript:noCaptcha.reset()","再来一次","或","https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"],
            _ggk_net_err: ["网络实在不给力<br/>请","javascript:noCaptcha.reset()","再来一次","或","https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"],
            _ggk_too_fast: ["您刮得太快啦<br/>请","javascript:noCaptcha.reset()","再来一次","或","https://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"]
            }
          }
        }
        resolve()
      })
    },
    yourRegisterRequest(url, params){
      var callbackName = ('jsonp_' + Math.random()).replace('.', '')
      params += '&callback=' + callbackName
      var o_scripts = document.getElementsByTagName("script")[0]
      var o_s = document.createElement('script')
      let that = this
      o_scripts.parentNode.insertBefore(o_s, o_scripts);
      //您注册请求的业务回调
      window[callbackName] = function(json) {
          if(json.result.code == 400) {
              //唤醒滑动验证
              getNC().then(function(){
                  _nvc_nc.upLang('cn', {
                      _startTEXT: "请按住滑块，拖动到最右边",
                      _yesTEXT: "验证通过",
                      _error300: "哎呀，出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次",
                      _errorNetwork: "网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>",
                  })
                  _nvc_nc.reset()
              })
          } else if (json.result.code == 600) {
              //唤醒刮刮卡
              getSC().then(function(){})
          } else if (json.result.code == 700) {
              //唤醒问答验证码
              getLC()
          } else if (json.result.code == 100 || json.result.code == 200) {
              //注册成功
            const data = {
              AfsSessionId: json.result.result.sessionId,
              AfsToken: window.NVC_Opt.Token,
              AfsSig: json.result.result.sig,
              AfsScene:  window.NVC_Opt.scene
            }
            that.getCode(data)
            nvcReset()
            // alert("register success!")
          } else if (json.result.code == 800 || json.result.code == 900) {
              //直接拦截
              nvcReset()
              // alert("register failed!")
          }
        }
        o_s.src = url + '?' + params
    }
  },
  mounted() {
    this.set_ALY_config().then(res=>{
      this.get_ALY_file()
    })
    window.localStorage.getItem('USER_ID') ? this.idFormData.tel = window.localStorage.getItem('USER_ID') : ''
    window.localStorage.getItem('USER_PHONE') ? this.formData.phone = window.localStorage.getItem('USER_PHONE') : ''
  }
};
</script>

<style lang="scss" scoped>
.token {
  width: 300px;
  height: 200px;
}



.login-wrapper {
  height: 100vh;
  background: url('https://static.wanfangche.com/21rv/static/bg-mp-login-3.jpg');
  background-size: cover;
  background-position: center center;
}

.middle {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  max-width: 400px;
  height: max-content;
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 40px;

  .tit {
    padding: 20px 0;
    font-size: 18px;
    text-align: center;
    display: flex;

    button {
      padding: 0;
      background: none;
      border: none;
      flex: 1;
      text-align: center;
    }

    button.active {
      color: #f04142 !important;
      font-weight: bold;
    }
  }

  .code {
    width: auto;
    margin-right: 10px;
  }

  .code-btn {
    width: 140px;
  }
}
</style>
